import {
  ACTIV_ASSURED_DIAMOND,
  ACTIV_CARE_CLASSIC,
  ACTIV_CARE_PREMIER,
  ACTIV_CARE_STANDARD,
  ACTIV_HEALTH_PLATINUM_ENHANCED,
  ACTIV_HEALTH_PLATINUM_ESSENTIAL,
  ADITYA_BIRLA,
  BAJAJ,
  CARE,
  CARE_SENIOR,
  CRITICAL_ILLNESS,
  CRITI_CARE,
  DIGIT,
  ELITE,
  ELITE_PLUS,
  FAMILY_HEALTH_PROTECTOR,
  formType,
  FUTURE_GENERALI,
  HDFC_ERGO,
  HEALTH_CARE_SUPREME,
  HEALTH_ENSURE_FAMILY_PLAN,
  HEALTH_GUARD,
  ICICI_LOMBARD,
  IFFCO_TOKIO,
  MY_HEALTH_PLUS_SURAKSHA,
  NIVA_BUPA_MAX,
  OPTIMA_RESTORE,
  OPTIMA_SECURE,
  RELIANCE,
  ResourceProductType,
  RE_ASSURE,
  SENIOR_FIRST,
  SHIELD,
  SHIELD_PLUS,
  SMART,
  STAR_HEALTH,
  TATA_AIG,
} from './constants';

export const Health: ResourceProductType = {
  [ADITYA_BIRLA]: {
    [ACTIV_ASSURED_DIAMOND]: [
      {
        formType: formType.PolicyBrochure,
        formLink:
          'https://github.com/PrishaPolicy/insurance-resources/raw/main/Health%20%26%20Accidental/Aditya%20Birla/Activ%20Assured%20Diamond/Activ%2BAssured%2Bdiamond-Brochure.pdf',
      },
      {
        formType: formType.PolicyWording,
        formLink:
          'https://github.com/PrishaPolicy/insurance-resources/raw/main/Health%20%26%20Accidental/Aditya%20Birla/Activ%20Assured%20Diamond/Activ%2BAssured%2Bdiamond-Policy%2Bwording.pdf',
      },
    ],
    [ACTIV_CARE_CLASSIC]: [
      {
        formType: formType.PolicyBrochure,
        formLink:
          'https://github.com/PrishaPolicy/insurance-resources/raw/main/Health%20%26%20Accidental/Aditya%20Birla/Activ%20Care%20Classic/Activ%2BCare-Brochure.pdf',
      },
      {
        formType: formType.PolicyWording,
        formLink:
          'https://github.com/PrishaPolicy/insurance-resources/raw/main/Health%20%26%20Accidental/Aditya%20Birla/Activ%20Care%20Classic/Activ%2BCare-Policy%2Bwording%20(1).pdf',
      },
    ],
    [ACTIV_CARE_PREMIER]: [
      {
        formType: formType.PolicyBrochure,
        formLink:
          'https://github.com/PrishaPolicy/insurance-resources/raw/main/Health%20%26%20Accidental/Aditya%20Birla/Activ%20Care%20Premier/Activ%2BCare-Brochure.pdf',
      },
      {
        formType: formType.PolicyWording,
        formLink:
          'https://github.com/PrishaPolicy/insurance-resources/raw/main/Health%20%26%20Accidental/Aditya%20Birla/Activ%20Care%20Premier/Activ%2BCare-Policy%2Bwording.pdf',
      },
    ],
    [ACTIV_CARE_STANDARD]: [
      {
        formType: formType.PolicyBrochure,
        formLink:
          'https://github.com/PrishaPolicy/insurance-resources/raw/main/Health%20%26%20Accidental/Aditya%20Birla/Activ%20Care%20Standard/Activ%2BCare-Brochure.pdf',
      },
      {
        formType: formType.PolicyWording,
        formLink:
          'https://github.com/PrishaPolicy/insurance-resources/raw/main/Health%20%26%20Accidental/Aditya%20Birla/Activ%20Care%20Standard/Activ%2BCare-Policy%2Bwording.pdf',
      },
    ],
    [ACTIV_HEALTH_PLATINUM_ENHANCED]: [
      {
        formType: formType.PolicyBrochure,
        formLink:
          'https://github.com/PrishaPolicy/insurance-resources/raw/main/Health%20%26%20Accidental/Aditya%20Birla/Activ%20Health%20Platinum%20Enhanced/Activ%2BHealth%2BPlatinum%2BEnhanced-Brochure.pdf',
      },
      {
        formType: formType.PolicyWording,
        formLink:
          'https://github.com/PrishaPolicy/insurance-resources/raw/main/Health%20%26%20Accidental/Aditya%20Birla/Activ%20Health%20Platinum%20Enhanced/Activ%2BHealth%2BPlatinum-Policy%2Bwording%20(1).pdf',
      },
    ],
    [ACTIV_HEALTH_PLATINUM_ESSENTIAL]: [
      {
        formType: formType.PolicyBrochure,
        formLink:
          'https://github.com/PrishaPolicy/insurance-resources/raw/main/Health%20%26%20Accidental/Aditya%20Birla/Activ%20Health%20Platinum%20Essential/Activ%2BHealth%2BPlatinum-Brochure.pdf',
      },
      {
        formType: formType.PolicyWording,
        formLink:
          'https://github.com/PrishaPolicy/insurance-resources/raw/main/Health%20%26%20Accidental/Aditya%20Birla/Activ%20Health%20Platinum%20Essential/Activ%2BHealth%2BPlatinum-Policy%2Bwording.pdf',
      },
    ],
  },
  [BAJAJ]: {
    [CRITICAL_ILLNESS]: [
      {
        formLink:
          'https://github.com/PrishaPolicy/insurance-resources/raw/main/Health%20%26%20Accidental/Bajaj%20Allianz/Critical%20Illness/bajaj-allianz-critical-illness-insurance-claim-form.pdf',
        formType: formType.ClaimForm,
      },
    ],
    [HEALTH_CARE_SUPREME]: [
      {
        formLink:
          'https://github.com/PrishaPolicy/insurance-resources/raw/main/Health%20%26%20Accidental/Bajaj%20Allianz/Health%20Care%20Supreme/Health%2BCare%2BSupreme-Brochure.pdf',
        formType: formType.PolicyWording,
      },
      {
        formLink:
          'https://github.com/PrishaPolicy/insurance-resources/raw/main/Health%20%26%20Accidental/Bajaj%20Allianz/Health%20Care%20Supreme/Health%2BCare%2BSupreme-Policy%2Bwording.pdf',
        formType: formType.PolicyBrochure,
      },
    ],
    [HEALTH_ENSURE_FAMILY_PLAN]: [
      {
        formLink:
          'https://github.com/PrishaPolicy/insurance-resources/raw/main/Health%20%26%20Accidental/Bajaj%20Allianz/Health%20Ensure%20Family%20Plan/Health%2BEnsure-Policy%2Bwording.pdf',
        formType: formType.PolicyWording,
      },
    ],
    [HEALTH_GUARD]: [
      {
        formLink:
          'https://github.com/PrishaPolicy/insurance-resources/raw/main/Health%20%26%20Accidental/Bajaj%20Allianz/Health%20Guard/Health%2BGuard-Brochure.pdf',
        formType: formType.PolicyBrochure,
      },
      {
        formLink:
          'https://github.com/PrishaPolicy/insurance-resources/raw/main/Health%20%26%20Accidental/Bajaj%20Allianz/Health%20Guard/Health%2BGuard-Policy%2Bwording.pdf',
        formType: formType.PolicyWording,
      },
    ],
  },
  [CARE]: {
    [CARE]: [
      {
        formType: formType.PolicyBrochure,
        formLink:
          'https://github.com/PrishaPolicy/insurance-resources/raw/main/Health%20%26%20Accidental/Care/Care/Care-Brochure.pdf',
      },
      {
        formType: formType.PolicyWording,
        formLink:
          'https://github.com/PrishaPolicy/insurance-resources/raw/main/Health%20%26%20Accidental/Care/Care/Care-Policy%2Bwording.pdf',
      },
    ],
    [CARE_SENIOR]: [
      {
        formType: formType.PolicyBrochure,
        formLink:
          'https://github.com/PrishaPolicy/insurance-resources/raw/main/Health%20%26%20Accidental/Care/Care%20senior/Care%2BSenior-Brochure.pdf',
      },
      {
        formType: formType.PolicyWording,
        formLink:
          'https://github.com/PrishaPolicy/insurance-resources/raw/main/Health%20%26%20Accidental/Care/Care%20senior/Care%2BSenior-Policy%2Bwording.pdf',
      },
    ],
  },
  [DIGIT]: {
    [SMART]: [
      {
        formType: formType.PolicyWording,
        formLink:
          'https://github.com/PrishaPolicy/insurance-resources/raw/main/Health%20%26%20Accidental/Digit/Smart/Digit-Policy%2Bwording.pdf',
      },
    ],
  },
  [FUTURE_GENERALI]: {
    [CRITI_CARE]: [
      {
        formLink:
          'https://github.com/PrishaPolicy/insurance-resources/raw/main/Health%20%26%20Accidental/Future%20Generali/Critical%20Illness/future-generali-criti-care-insurance-claim-form.pdf',
        formType: formType.ClaimForm,
      },
    ],
  },
  [HDFC_ERGO]: {
    [CRITICAL_ILLNESS]: [
      {
        formLink:
          'https://github.com/PrishaPolicy/insurance-resources/raw/main/Health%20%26%20Accidental/HDFC%20Ergo/Critical%20Illness/hdfc-ergo-critical-illness-insurance-claim-form.pdf',
        formType: formType.ClaimForm,
      },
    ],
    [OPTIMA_RESTORE]: [
      {
        formLink:
          'https://github.com/PrishaPolicy/insurance-resources/raw/main/Health%20%26%20Accidental/HDFC%20Ergo/Complete%20Health/Optima%2BRestore-Brochure.pdf',
        formType: formType.PolicyBrochure,
      },
      {
        formLink:
          'https://github.com/PrishaPolicy/insurance-resources/raw/main/Health%20%26%20Accidental/HDFC%20Ergo/Complete%20Health/Optima%2BRestore-Policy%2BWording.pdf',
        formType: formType.PolicyWording,
      },
    ],
    [OPTIMA_SECURE]: [
      {
        formLink:
          'https://github.com/PrishaPolicy/insurance-resources/raw/main/Health%20%26%20Accidental/HDFC%20Ergo/Complete%20Health/Optima%2BSecure-Brochure.pdf',
        formType: formType.PolicyBrochure,
      },
      {
        formLink:
          'https://github.com/PrishaPolicy/insurance-resources/blob/main/Health%20%26%20Accidental/HDFC%20Ergo/Complete%20Health/Optima%2BSecure-Policy%2Bwording.pdf',
        formType: formType.PolicyWording,
      },
    ],
    [MY_HEALTH_PLUS_SURAKSHA]: [
      {
        formLink:
          'https://github.com/PrishaPolicy/insurance-resources/raw/main/Health%20%26%20Accidental/HDFC%20Ergo/Complete%20Health/myHealth%2BSuraksha-Brochure.pdf',
        formType: formType.PolicyBrochure,
      },
      {
        formLink:
          'https://github.com/PrishaPolicy/insurance-resources/raw/main/Health%20%26%20Accidental/HDFC%20Ergo/Complete%20Health/myHealth%2BSuraksha-Policy%2Bwording.pdf',
        formType: formType.PolicyWording,
      },
    ],
  },
  [ICICI_LOMBARD]: {
    [ELITE]: [
      {
        formLink:
          'https://github.com/PrishaPolicy/insurance-resources/raw/main/Health%20%26%20Accidental/ICICI%20Lombard/Elite/ICICI%20Lombard%20CHI%20Brochure_New%20Features%5B1%5D%20(1).pdf',
        formType: formType.PolicyBrochure,
      },
      {
        formLink:
          'https://github.com/PrishaPolicy/insurance-resources/raw/main/Health%20%26%20Accidental/ICICI%20Lombard/Elite/complete-health-insurance-(health-elite).pdf',
        formType: formType.PolicyWording,
      },
    ],
    [ELITE_PLUS]: [
      {
        formLink:
          'https://github.com/PrishaPolicy/insurance-resources/raw/main/Health%20%26%20Accidental/ICICI%20Lombard/Elite%20Plus/ICICI%20Lombard%20CHI%20Brochure_New%20Features%5B1%5D%20(1).pdf',
        formType: formType.PolicyBrochure,
      },
      {
        formLink:
          'https://github.com/PrishaPolicy/insurance-resources/raw/main/Health%20%26%20Accidental/ICICI%20Lombard/Elite%20Plus/complete-health-insurance-(health-elite-plus).pdf',
        formType: formType.PolicyWording,
      },
    ],
    [SHIELD]: [
      {
        formLink:
          'https://github.com/PrishaPolicy/insurance-resources/raw/main/Health%20%26%20Accidental/ICICI%20Lombard/Shield%20Plus/ICICI%20Lombard%20CHI%20Brochure_New%20Features%5B1%5D%20(1).pdf',
        formType: formType.PolicyBrochure,
      },
      {
        formLink:
          'https://github.com/PrishaPolicy/insurance-resources/raw/main/Health%20%26%20Accidental/ICICI%20Lombard/Shield/complete-health-insurance-(health-shield).pdf',
        formType: formType.PolicyWording,
      },
    ],
    [SHIELD_PLUS]: [
      {
        formLink:
          'https://github.com/PrishaPolicy/insurance-resources/raw/main/Health%20%26%20Accidental/ICICI%20Lombard/Shield%20Plus/ICICI%20Lombard%20CHI%20Brochure_New%20Features%5B1%5D%20(1).pdf',
        formType: formType.PolicyBrochure,
      },
      {
        formLink:
          'https://github.com/PrishaPolicy/insurance-resources/raw/main/Health%20%26%20Accidental/ICICI%20Lombard/Shield%20Plus/complete-health-insurance-(health-shield-plus).pdf',
        formType: formType.PolicyWording,
      },
    ],
  },
  [IFFCO_TOKIO]: {
    [FAMILY_HEALTH_PROTECTOR]: [
      {
        formType: formType.PolicyBrochure,
        formLink:
          'https://github.com/PrishaPolicy/insurance-resources/raw/main/Health%20%26%20Accidental/Iffco%20Tokio/Family%20Health%20Protector/Family%2BHealth%2BProtector-%2BPolicy%2BBrochure.pdf',
      },
      {
        formType: formType.PolicyWording,
        formLink:
          'https://github.com/PrishaPolicy/insurance-resources/raw/main/Health%20%26%20Accidental/Iffco%20Tokio/Family%20Health%20Protector/Family%2BHealth%2BProtector-%2BPolicy%2Bwording.pdf',
      },
    ],
  },
  [NIVA_BUPA_MAX]: {
    [RE_ASSURE]: [
      {
        formType: formType.PolicyBrochure,
        formLink:
          'https://github.com/PrishaPolicy/insurance-resources/raw/main/Health%20%26%20Accidental/Niva%20Bupa%20(Max)/ReAssure/ReAssure-Brochure.pdf',
      },
      {
        formType: formType.PolicyWording,
        formLink:
          'https://github.com/PrishaPolicy/insurance-resources/raw/main/Health%20%26%20Accidental/Niva%20Bupa%20(Max)/ReAssure/ReAssure-Policy%2BWordings.pdf',
      },
      {
        formType: formType.ProposalForm,
        formLink:
          'https://github.com/PrishaPolicy/insurance-resources/raw/main/Health%20%26%20Accidental/Niva%20Bupa%20(Max)/ReAssure/Reassure-RETAIL-AppForm.pdf',
      },
    ],
    [SENIOR_FIRST]: [
      {
        formType: formType.ClaimForm,
        formLink:
          'https://github.com/PrishaPolicy/insurance-resources/raw/main/Health%20%26%20Accidental/Niva%20Bupa%20(Max)/Senior%20first/Niva_Claim-Reimb%20form_v2.pdf',
      },
      {
        formType: formType.PolicyWording,
        formLink:
          'https://github.com/PrishaPolicy/insurance-resources/raw/main/Health%20%26%20Accidental/Niva%20Bupa%20(Max)/Senior%20first/Senior%20First_Policy_Wordings.pdf',
      },
      {
        formType: formType.ProposalForm,
        formLink:
          'https://github.com/PrishaPolicy/insurance-resources/raw/main/Health%20%26%20Accidental/Niva%20Bupa%20(Max)/Senior%20first/Senior%20First%20-%20Proposal%20Form_draft%20v17_wtihlogo.pdf',
      },
    ],
  },
  [RELIANCE]: {
    [CRITICAL_ILLNESS]: [
      {
        formType: formType.ClaimForm,
        formLink:
          'https://github.com/PrishaPolicy/insurance-resources/raw/main/Health%20%26%20Accidental/Reliance%20General/Critical%20Illness/reliance-critical-illness-insurance-claim-form.pdf',
      },
    ],
  },
  [STAR_HEALTH]: {
    [CRITICAL_ILLNESS]: [
      {
        formLink:
          'https://github.com/PrishaPolicy/insurance-resources/raw/main/Health%20%26%20Accidental/Star%20Health/Critical%20Illness/star-health-criticare%20plus-insurance-claim-form.pdf',
        formType: formType.ClaimForm,
      },
    ],
  },
  [TATA_AIG]: {
    [CRITICAL_ILLNESS]: [
      {
        formType: formType.ClaimForm,
        formLink:
          'https://github.com/PrishaPolicy/insurance-resources/raw/main/Health%20%26%20Accidental/Tata%20AIG/Critical%20Illness/tata-aig-critical-illness-insurance-claim-form.pdf',
      },
    ],
  },
};
